import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

import ListItem, { LIST_ITEM } from "./ListItem.vue";

export type ListClassesKey = "listItem";

type Props = {
  list?: LIST_ITEM[];
  link?: boolean;
  showCheckbox?: boolean;
  classes?: Partial<Record<ListClassesKey, string>>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    list: { default: () => [] },
    link: { type: Boolean },
    showCheckbox: { type: Boolean, default: false },
    classes: { default: () => ({}) }
  },
  emits: ["onSelect"],
  setup(__props: any, { emit: emits }) {




const onSelectItem = (itemValue: LIST_ITEM) => {
  emits("onSelect", itemValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", {
      sample: "ok",
      click: onSelectItem
    }, () => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createBlock(ListItem, {
          key: item.value,
          class: _normalizeClass([_ctx.classes?.listItem]),
          link: _ctx.link,
          item: item,
          "show-checkbox": _ctx.showCheckbox,
          onOnClick: onSelectItem
        }, null, 8, ["class", "link", "item", "show-checkbox"]))
      }), 128))
    ])
  ]))
}
}

})